"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var numberMeasure_1 = require("../measure/numberMeasure");
var base_1 = require("./base");
exports.hertz = base_1.seconds.inverse().withSymbol("Hz");
exports.newtons = base_1.kilograms.times(base_1.meters.per(base_1.seconds.squared())).withSymbol("N");
exports.pascals = exports.newtons.per(base_1.meters.squared()).withSymbol("Pa");
exports.joules = exports.newtons.times(base_1.meters).withSymbol("N");
exports.watts = exports.joules.per(base_1.seconds).withSymbol("J");
exports.volts = exports.watts.per(base_1.amperes).withSymbol("V");
exports.coulombs = base_1.amperes.times(base_1.seconds).withSymbol("C");
exports.farads = exports.coulombs.per(exports.volts).withSymbol("F");
exports.ohms = exports.volts.per(base_1.amperes).withSymbol("Ω");
exports.siemens = base_1.amperes.per(exports.volts).withSymbol("S");
exports.henrys = exports.ohms.times(base_1.seconds).withSymbol("H");
exports.webers = exports.joules.per(base_1.amperes).withSymbol("Wb");
exports.teslas = exports.volts.times(base_1.seconds.per(base_1.meters.squared())).withSymbol("T");
exports.sieverts = exports.joules.per(base_1.kilograms).withSymbol("Sv");
exports.katals = base_1.moles.per(base_1.seconds).withSymbol("kat");
exports.lumens = base_1.candelas.times(base_1.steradians).withSymbol("lm");
exports.luxes = exports.lumens.per(base_1.meters.squared()).withSymbol("lx");
// HACKHACK: Explicitly type this so we can import PrefixFunction and avoid absolute paths in the generated typings.
exports.yotta = numberMeasure_1.Measure.prefix("Y", 1e24);
exports.zetta = numberMeasure_1.Measure.prefix("Z", 1e21);
exports.exa = numberMeasure_1.Measure.prefix("E", 1e18);
exports.peta = numberMeasure_1.Measure.prefix("P", 1e15);
exports.tera = numberMeasure_1.Measure.prefix("T", 1e12);
exports.giga = numberMeasure_1.Measure.prefix("G", 1e9);
exports.mega = numberMeasure_1.Measure.prefix("M", 1e6);
exports.kilo = numberMeasure_1.Measure.prefix("k", 1e3);
exports.hecto = numberMeasure_1.Measure.prefix("h", 100);
exports.deca = numberMeasure_1.Measure.prefix("da", 10);
exports.deci = numberMeasure_1.Measure.prefix("d", 0.1);
exports.centi = numberMeasure_1.Measure.prefix("c", 0.01);
exports.milli = numberMeasure_1.Measure.prefix("m", 1e-3);
exports.micro = numberMeasure_1.Measure.prefix("µ", 1e-6);
exports.nano = numberMeasure_1.Measure.prefix("n", 1e-9);
exports.pico = numberMeasure_1.Measure.prefix("p", 1e-12);
exports.femto = numberMeasure_1.Measure.prefix("f", 1e-15);
exports.atto = numberMeasure_1.Measure.prefix("y", 1e-18);
exports.zepto = numberMeasure_1.Measure.prefix("z", 1e-21);
exports.yocto = numberMeasure_1.Measure.prefix("y", 1e-24);
//# sourceMappingURL=metric.js.map